// extracted by mini-css-extract-plugin
export var Backdrop = "style-module--Backdrop--06ef9";
export var LogoWrapper = "style-module--LogoWrapper--a090b";
export var SplashLogo = "style-module--SplashLogo--cbe16";
export var SplashScreen = "style-module--SplashScreen--3bae8";